import { Component, OnInit } from '@angular/core';
import { StudentService } from '../services/student.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-ninja-activity-history',
  templateUrl: './ninja-activity-history.component.html',
  styleUrls: ['./ninja-activity-history.component.css']
})
export class NinjaActivityHistoryComponent implements OnInit {
importhistory:any=[];
  constructor(private studentService: StudentService, private toastr: ToastrService) { }

  ngOnInit() {

    this.getNinjaActivityHistory("Ninja Activity");
  }

  getNinjaActivityHistory(importtype) {
    this.studentService.GetImportFileHistory(importtype).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.importhistory = res.Data;
      }

    });
  }
}
